const SOURCE_URL =
  "https://open.overheid.nl/documenten/77025de3-b7e9-4cd0-b7b2-09913b79d3e8/";

const PLAYERS = [
  { label: "Alleen bij legale aanbieders", value: 480, tone: "bg-primary" },
  { label: "Legaal én illegaal", value: 20, tone: "bg-muted-foreground/60" },
  { label: "Alleen bij illegale aanbieders", value: 30, tone: "bg-destructive" },
];

const KPIS = [
  { value: "111.534", label: "personen ingeschreven in Cruks", note: "stand 30 januari 2026" },
  { value: "± 2.150", label: "netto groei Cruks per maand", note: "10,5k in- vs 9k uitschrijvingen (dec. 2025)" },
  { value: "52%", label: "staat korter dan een half jaar in Cruks", note: "helft is jonger dan 32 jaar" },
  { value: "2.708", label: "mensen in behandeling voor gokverslaving", note: "LADIS 2024, +10% t.o.v. 2023" },
];

/** Infographic with public KSA figures (Monitoringsrapportage online kansspelen, voorjaar 2026). */
export function CruksStatsInfographic() {
  const total = PLAYERS.reduce((s, p) => s + p.value, 0);
  return (
    <figure
      id="infographic-cruks-statistieken"
      className="rounded-xl border border-border bg-card p-5 sm:p-6"
    >
      <figcaption className="text-base font-semibold text-foreground">
        Online gokken zonder Cruks in cijfers: legale vs. illegale markt (2e helft 2025)
      </figcaption>
      <p className="mt-1 text-xs text-muted-foreground">
        Officiële cijfers van de Kansspelautoriteit; illegale aanbieders controleren Cruks niet.
      </p>

      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        <div className="rounded-lg bg-secondary/60 p-4">
          <p className="text-3xl font-bold tabular-nums text-foreground">91–95%</p>
          <p className="mt-1 text-sm text-foreground">kanalisatie naar spelersaantal</p>
          <p className="text-xs text-muted-foreground">aandeel spelers dat (ook) legaal speelt</p>
        </div>
        <div className="rounded-lg bg-secondary/60 p-4">
          <p className="text-3xl font-bold tabular-nums text-foreground">53%</p>
          <p className="mt-1 text-sm text-foreground">kanalisatie naar brutospelresultaat</p>
          <p className="text-xs text-muted-foreground">
            gedaald van 56%: ±47% van de verliezen ligt bij illegale sites
          </p>
        </div>
      </div>

      <p className="mt-6 text-sm font-medium text-foreground">
        Gemiddeld aantal online spelers per maand (×1.000; Ksa-totaal 520, afgeronde deelcijfers)
      </p>
      <div className="mt-2 flex h-4 overflow-hidden rounded-full bg-secondary" aria-hidden>
        {PLAYERS.map((p) => (
          <div key={p.label} className={p.tone} style={{ width: `${(p.value / total) * 100}%` }} />
        ))}
      </div>
      <ul className="mt-3 grid gap-1.5 text-xs text-muted-foreground sm:grid-cols-3">
        {PLAYERS.map((p) => (
          <li key={p.label} className="flex items-center gap-2">
            <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${p.tone}`} />
            <span>
              {p.label}: <strong className="tabular-nums text-foreground">{p.value}k</strong>
            </span>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-muted-foreground">
        Kleine groep, groot verlies: minder dan 10% van de spelers speelt (ook) illegaal, maar daar ligt bijna de
        helft van het brutospelresultaat. Volgens de Ksa lijden illegale spelers dus gemiddeld
        aanzienlijk hogere verliezen.
      </p>

      <dl className="mt-6 grid gap-3 sm:grid-cols-2">
        {KPIS.map((k) => (
          <div key={k.label} className="rounded-lg border border-border p-4">
            <dt className="text-sm text-foreground">{k.label}</dt>
            <dd className="mt-1 text-2xl font-bold tabular-nums text-foreground">{k.value}</dd>
            <dd className="text-xs text-muted-foreground">{k.note}</dd>
          </div>
        ))}
      </dl>

      <p className="mt-5 border-t border-border pt-3 text-xs leading-relaxed text-muted-foreground">
        Bron:{" "}
        <a href={SOURCE_URL} target="_blank" rel="noopener" className="underline hover:text-foreground">
          Kansspelautoriteit, Monitoringsrapportage online kansspelen voorjaar 2026
        </a>{" "}
        (hfst. 3 en 5; spelerscijfers via GfK-panel, BSR via Google Ads-zoekvolume na correctie,
        behandelcijfers via LADIS). Cijfers over de illegale markt zijn schattingen; de Ksa
        waarschuwt voor voorzichtigheid bij extrapolatie.
      </p>
    </figure>
  );
}
